import { useOrganizationStore } from '@shared/hooks/state/OrganizationContainer';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { useAlertsStore } from './state/AlertsContainer';

export function useOrgProductFetching() {
    const { t, i18n } = useTranslation();
    const { organizationId } = useParams<{ organizationId: string }>();
    const orgProducts = useOrganizationStore((state) => state.orgProducts);
    const isLoading = useOrganizationStore((state) => state.loadingData.products);

    useEffect(() => {
        async function initializeOrgProducts() {
            if (!organizationId || useOrganizationStore.getState().loadingData.products == true) return;
            useOrganizationStore.getState().handleLoadingDataChange('products', true);
            const product = useOrganizationStore
                .getState()
                .orgProducts.find((p) => p.organizationId === organizationId);

            if (product) {
                useOrganizationStore.getState().handleLoadingDataChange('products', false);
                return;
            }

            try {
                await useOrganizationStore.getState().getOrganizationProducts(organizationId, i18n.language);
            } catch (error) {
                useAlertsStore.getState().showError(t('common:license.key.product.error.title'));
            } finally {
                useOrganizationStore.getState().handleLoadingDataChange('products', false);
            }
        }
        initializeOrgProducts();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [organizationId]);

    return { orgProducts, isLoading };
}
